export default __webpack_public_path__ + "static/media/Smartle3.d3665c9c.png";